import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import { AnimatedMascot } from 'components/Mascot';
import { routePaths } from 'global/routePaths';
import { useDisconnectXero } from 'hooks/integrations/useDisconnectXero';
import { useFetchXeroAuthCode } from 'hooks/integrations/useFetchAuthCodeXero';
import { useSaveXeroAuthCode } from 'hooks/integrations/useSaveXeroAuthCode';
import { useIntegrationStore } from 'store/useIntegrationStore';

const Configuration = () => {
  const navigate = useNavigate();

  const { t } = useTranslation(['integrations', 'common', 'employees']);

  const { data: xeroOauthUrlData, status: xeroOauthUrlStatus } = useFetchXeroAuthCode();
  const { status: xeroAuthSaveStatus, mutate: xeroAuthSaveMutate } = useSaveXeroAuthCode();
  const { status: xeroDisconnectStatus, mutate: xeroDisconnectMutate } = useDisconnectXero();

  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const xeroIntegrationData = integrationListData.filter((tab: any) => tab.key === 'xero')[0];

  const getCode = (e: any) => {
    const tempFix = e.origin + '/';
    if (tempFix === import.meta.env.VITE_CURRENT_URL) {
      window.removeEventListener('message', getCode);
      xeroAuthSaveMutate(e.data);
    }
  };

  const onEnable = () => {
    if (xeroOauthUrlStatus === 'success') {
      window.open(xeroOauthUrlData.payload, 'Xero login', 'width=600, height=420');
      window.addEventListener('message', getCode);
    }
  };

  const onDisbale = () => {
    xeroDisconnectMutate();
  };

  return (
    <>
      {!xeroIntegrationData.is_connected ? (
        <Flex flexDirection="column">
          <Box
            padding="20px 40px"
            border="1px solid"
            borderColor="gray.400"
            background="white"
            textAlign="center"
            mb={6}
          >
            <AnimatedMascot type="barking" />
            <Text>{t('integrations:clickToEnable')}</Text>
          </Box>
          <Button ml="auto" isLoading={xeroAuthSaveStatus === 'loading'} onClick={onEnable}>
            {t('integrations:enable')}
          </Button>
        </Flex>
      ) : (
        <Flex flexDirection="column">
          <Box
            padding="20px 40px"
            border="1px solid"
            borderColor="gray.400"
            background="white"
            textAlign="center"
            mb={6}
          >
            <Text>{t('integrations:clickToDisable')}</Text>
          </Box>
          <Box textAlign="right">
            <Button
              _hover={{ bg: 'rgba(255, 103, 32, 0.2)' }}
              background="rgba(255, 103, 32, 0.1)"
              colorScheme="rgba(255, 103, 32, 0.3)"
              color="secondary.500"
              mr={2}
              onClick={() => navigate(routePaths.integrations.xero.mapping)}
            >
              {t('integrations:viewMapping')}
            </Button>
            <Button
              ml="auto"
              fontWeight="bold"
              background="rgba(250, 85, 85, 0.2)"
              color="rgba(250, 85, 85, 1)"
              _hover={{ bg: 'secondary.100' }}
              isLoading={xeroDisconnectStatus === 'loading'}
              onClick={onDisbale}
            >
              {t('integrations:generalDisconnect')}
            </Button>
          </Box>
        </Flex>
      )}
    </>
  );
};
export default Configuration;
